import Vue from 'vue';
// eslint-disable-next-line import/no-cycle
import feathersClient from '../../feathers-client';

const defaultSnowflakeRosterHistoryPagination = {
	total: 100,
	$skip: 0,
	$limit: 6,
};
const defaultSnowflakeRosterHistoryFilter = {
	$skip: defaultSnowflakeRosterHistoryPagination.$skip,
	$limit: defaultSnowflakeRosterHistoryPagination.$limit,
};
export default {
	namespaced: true,
	state: {
		snowflakeRosterHistory: [],
		snowflakeRosterHistoryPagination: defaultSnowflakeRosterHistoryPagination,
		SnowflakeRosterHistoryFilter: defaultSnowflakeRosterHistoryFilter,
	},
	getters: {
		setSnowflakeRosterHistoryPage: (state) => {
			const { $limit, $skip } = state.snowflakeRosterHistoryPagination;
			return $skip / $limit + 1;
		},
	},
	mutations: {
		SET_SNOWFLAKE_ROSTER_HISTORY: (state, data) => { state.snowflakeRosterHistory = data; },
		SET_SNOWFLAKE_ROSTER_HISTORY_PAGINATION: (state, data) => { state.snowflakeRosterHistoryPagination = { ...state.snowflakeRosterHistoryPagination, ...data }; },
		SET_SNOWFLAKE_ROSTER_HISTORY_FILTER: (state, filter) => { state.SnowflakeRosterHistoryFilter = { ...state.SnowflakeRosterHistoryFilter, ...filter }; },
		SET_SNOWFLAKE_ROSTER_HISTORY_PERMISSION: (state, snowflakeRosterHistoryPermission) => { state.snowflakeRosterHistoryPermission = snowflakeRosterHistoryPermission; },
	},
	actions: {
		setSnowflakeRosterHistoryFilter: ({ commit }, filter) => {
			commit('SET_SNOWFLAKE_ROSTER_HISTORY_FILTER', filter);
		},
		setSnowflakeRosterHistoryListPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.snowflakeRosterHistoryPagination.$limit;
			commit('SET_SNOWFLAKE_ROSTER_HISTORY_PAGINATION', { $skip });
			commit('SET_SNOWFLAKE_ROSTER_HISTORY_FILTER', { $skip });
		},
		getAllSnowflakeRosterHistoryForTrust: async({ rootGetters, commit }, filter) => {
			const results = await feathersClient.service('api/v3/roster-shift-import-status').find({
				query: {
					$sort: { uploadedAt: -1 },
					...filter,
					$role: rootGetters.currentUserRole,
				},
			});
			commit('SET_SNOWFLAKE_ROSTER_HISTORY', results.data);
			commit('SET_SNOWFLAKE_ROSTER_HISTORY_PAGINATION', { total: results.total });
			return results.data;
		},
		getFailesRosterShifts:  async({ rootGetters }, filter) => {
			const results = await feathersClient.service('api/v3/roster-shift-import-status').find({
				query: {
					...filter,
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
	},
};
